
import CenteredLayout from '@/components/layouts/CenteredLayout.vue'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import Auth from '@/plugins/firebase/auth'
import { RegisterRequest } from '@/models/auth'
import { Form as VeeForm } from 'vee-validate'
import { useAlerts } from '@/mixins'
import { defineComponent } from 'vue'
export default defineComponent({
  components: { CenteredLayout, VeeForm },
  setup: () => {
    const { t } = useI18n()
    const loading = ref(false)
    const initialValues = ref({
      name: ''
    })
    const { message } = useAlerts('succcess')

    // fields instance

    const register = async (values: RegisterRequest): Promise<void> => {
      //// // console.log(values)

      loading.value = true
      try {
        const response = await Auth.register(values as RegisterRequest)
        // // console.log(response)
        message.value.type = 'success'
        message.value.message = t('signup.success_message')
        loading.value = false
      } catch (e) {
        console.error(e)
        message.value.type = 'error'
        message.value.message = t('signup.error_message')
        loading.value = false
        alert(e)
      }
    }

    return {
      initialValues,
      loading,
      t,
      register,
      message
    }
  }
})
